import { css, keyframes } from 'styled-components';
import colors from '../../../helpers/colors';
import { themeSpecificColors } from '../colors';

export const focusBoxShadowStyle = css`
  box-shadow: 0 0 0 1px ${colors.core01}, 0 0 0 2px ${colors.neutral08},
    0 0 0 6px ${themeSpecificColors.core01_60};
`;

export const headerBoxShadowStyle = css`
  box-shadow: 0px 2px 0px #dbd3e2;
`;

const shadowAnimation = keyframes`
  0% {
    box-shadow: none;
  }
  100% {
    box-shadow: 0px 2px 0px ${themeSpecificColors.core01_20};
  }
`;

const animationTime = '300ms';

export const interactionStatesForCards = css`
  outline: 1px solid transparent;

  &:active {
    background-color: ${themeSpecificColors.core01_10};
    border: 1px solid ${colors.core01};
    outline: 1px solid ${colors.core01};
  }

  &:hover,
  &:focus-visible {
    animation: ${shadowAnimation} ${animationTime} ease-out forwards;
    outline: 1px solid ${themeSpecificColors.core01_20};
  }

  &:focus-visible {
    outline: 4px solid ${themeSpecificColors.core01_60};
    outline-offset: 1px;
  }
`;
